module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_int_04_6DD79_1SE_H2X.a1d8ea25.jpg";